import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { FETCH_MANAGEMENT_TAGS_ASYNC } from '../constants'

import {
  fetchAllTagsError,
  fetchAllTagsSuccess,
  fetchDepartmentsError,
  fetchDepartmentsSuccess,
  fetchTitlesError,
  fetchTitlesSuccess,
} from './actions'
import { FETCH_ALL_TAGS_ASYNC, FETCH_DEPARTMENTS_ASYNC, FETCH_TITLES_ASYNC } from './constants'

const fetchAllTagsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_ALL_TAGS_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: store.getState().partnerOptions.selectedCompany?.value,
          allTags: false,
          page: store.getState().mailboxes.addMailbox.allTags.page,
          search: store.getState().mailboxes.addMailbox.allTags.search,
          source: 'reduced',
        })
        .map((response) => fetchAllTagsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchAllTagsError, error)))
        .takeUntil(action$.ofType(FETCH_MANAGEMENT_TAGS_ASYNC.CANCEL))
    )

const fetchTitlesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_TITLES_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: store.getState().partnerOptions.selectedCompany?.value,
          allTags: false,
          page: store.getState().mailboxes.addMailbox.titles.page,
          search: store.getState().mailboxes.addMailbox.titles.search,
          source: 'title',
        })
        .map((response) => fetchTitlesSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchTitlesError, error)))
        .takeUntil(action$.ofType(FETCH_TITLES_ASYNC.CANCEL))
    )

const fetchDepartmentsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_DEPARTMENTS_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.management) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: store.getState().partnerOptions.selectedCompany?.value,
          allTags: false,
          page: store.getState().mailboxes.addMailbox.departments.page,
          search: store.getState().mailboxes.addMailbox.departments.search,
          source: 'department',
        })
        .map((response) => fetchDepartmentsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDepartmentsError, error)))
        .takeUntil(action$.ofType(FETCH_DEPARTMENTS_ASYNC.CANCEL))
    )

export default combineEpics(fetchAllTagsEpic, fetchDepartmentsEpic, fetchTitlesEpic)
